module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60d46902ec6c55f7896dee4cb2e0ef32.png";